<template>
  <div class="grid-view">
    <div class="main-content">
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :config-module="configModule"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :export-file-name="priceUtil.getFileName(fileName)"
          :row-data="rowData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import * as NumberUtils from '@/utils/NumberUtils'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'

export default {
  name: 'WeightLimitDataGrid',
  components: {
  },
  props: {
    configModule: { type: String, default: '', required: true },
    showCreate: { type: Boolean, default: false },
    showModify: { type: Boolean, default: false },
    showApprove: { type: Boolean, default: false },
    showSelection: { type: Boolean, default: false },
    gridOptions: { type: Object, default: () => {} },
    currency: { type: String, default: '' },
    fileName: { type: String, default: 'PriceWeightLimit' },
    allIn: { type: Boolean, default: false },
    rowData: { type: Array, default: () => [] }
  },
  data() {
    return {
      tenantUtil: {},
      priceUtil: PriceUtils,
      gridParams: {},
      gridApi: null,
      columnDefs: [
        {
          headerName: ' ', maxWidth: 30, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          hide: !this.showSelection, suppressColumnsToolPanel: !this.showSelection,
          headerCheckboxSelection: true
        },
        {
          colId: 'pol',
          field: 'pol',
          headerName: this.$t('Pricing.POL'),
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltipValueGetter: (params) => {
            return params.value
          }
        },
        {
          colId: 'pod',
          field: 'pod',
          headerName: this.$t('Pricing.POD'),
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltipValueGetter: (params) => {
            return params.value
          }
        },
        {
          colId: 'via',
          field: 'via',
          headerName: this.$t('Pricing.Via'),
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltipValueGetter: (params) => {
            return params.value
          }
        },
        {
          colId: 'carrier',
          field: 'carrier',
          headerName: this.$t('Pricing.Carrier'),
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'shortName')
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          colId: 'isFrequency',
          field: 'isFrequency',
          headerName: this.$t('Pricing.DepartureDay'),
          valueFormatter: (params) => {
            return PriceUtils.frequencyLabelFunc(params.data, 'frequency')
          }
        },
        {
          colId: 'eqType',
          field: 'eqType',
          headerName: this.$t('Pricing.EqType')
        },
        {
          colId: 'eqSize',
          field: 'eqSize',
          headerName: this.$t('Pricing.Measurement')
        },
        {
          colId: 'gradeMin',
          field: 'gradeMin',
          headerName: this.$t('Pricing.WeightRule'),
          valueFormatter: this.gradeMinLabelFunc
        },
        {
          colId: 'currency',
          field: 'currency',
          headerName: this.$t('Pricing.Currency')
        },
        {
          colId: 'amount',
          field: 'amount',
          headerName: this.$t('Pricing.Amount'),
          valueFormatter: this.numberColumnLabelFunc
        },
        {
          colId: 'remarks',
          field: 'remarks',
          headerName: this.$t('Pricing.Remarks')
        },
        { headerName: this.$t('Pricing.BeginDateCol'), field: 'beginDate', colId: 'beginDate', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.EndDateCol'), field: 'endDate', colId: 'endDate', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.Branch'), field: 'branchId', colId: 'branchId', width: 200,
          hide: !this.showCreate, suppressColumnsToolPanel: !this.showCreate,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', params.value, 'code')
          } },
        { headerName: this.$t('Pricing.CreatedBy'), field: 'createdBy', colId: 'createdBy', width: 200,
          hide: !this.showCreate, suppressColumnsToolPanel: !this.showCreate,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.userToolTipLabel(params.value)
          } },
        { headerName: this.$t('Pricing.CreatedDate'), field: 'dateCreated', colId: 'dateCreated', width: 200,
          hide: !this.showCreate, suppressColumnsToolPanel: !this.showCreate,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.ModifiedBy'), field: 'modifiedBy', colId: 'modifiedBy', width: 200,
          hide: !this.showModify, suppressColumnsToolPanel: !this.showModify,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.userToolTipLabel(params.value)
          } },
        { headerName: this.$t('Pricing.ModifiedDate'), field: 'dateModified', colId: 'dateModified', width: 200,
          hide: !this.showModify, suppressColumnsToolPanel: !this.showModify,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.ApprovedBy'), field: 'approvedBy', colId: 'approvedBy', width: 200,
          hide: !this.showApprove, suppressColumnsToolPanel: !this.showApprove,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.userToolTipLabel(params.value)
          } },
        { headerName: this.$t('Pricing.ApprovedDate'), field: 'dateApproved', colId: 'dateApproved', width: 200,
          hide: !this.showApprove, suppressColumnsToolPanel: !this.showApprove,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }
      ]
    }
  },
  methods: {
    gradeMinLabelFunc(params) {
      const { data } = params
      if (data.gradeMin !== PriceConstant.NIL) {
        if (data.gradeMax !== PriceConstant.NIL) {
          return data.gradeMin + '-' + data.gradeMax
        } else {
          return '＞' + data.gradeMin
        }
      } else {
        if (data.gradeMax !== PriceConstant.NIL) {
          return '≤' + data.gradeMax
        }
      }
      return ''
    },
    numberColumnLabelFunc(params) {
      const { value, data } = params
      const { targetCurrency } = this
      if (value === 0) return 0
      if (!isNaN(value)) {
        if (value === PriceConstant.NIL) return ''
        if (targetCurrency && data['currency'] !== targetCurrency) {
          const rate = RateUtil.getForeignExchangeRateSafely(data['currency'], targetCurrency, new Date(), 0)
          if (rate > 0) {
            const price = value / rate
            if (price < 0) return `(${NumberUtils.roundHalfUp(-price)})`
            return NumberUtils.roundHalfUp(price).toFixed(2)
          }
        } else {
          if (value < 0) return `(${NumberUtils.roundHalfUp(-value)})`
        }
        return NumberUtils.roundHalfUp(value).toFixed(2)
      }
      return ''
    }
  }
}
</script>
<style lang="scss">
</style>

